export default __webpack_public_path__ + "static/media/eed13f47c3ce0a435dd2cf1facd9580e1600818233724.1fbefda2.webp";